import { systemConfigDetail } from './request';
export default {
  data() {
    return {
      fileContent: ''
    };
  },
  mounted() {
    this.getSystemConfigDetail();
  },
  methods: {
    async getSystemConfigDetail() {
      let res = await systemConfigDetail({
        id: this.$route.params.id,
        type: this.$route.params.type,
        language: this.$route.params.language
      });
      console.log(res, 'res');
      this.fileContent = res.fileContent;
    }
  }
};